import dayjs from "dayjs";
import { getInitialFilters } from "../../../utils/filters";
import * as actionTypes from "./actionTypes";

const reportingInitialState = {
  corzapReports: [],
  customReports: [],
  reportData: {},
  loadingReportData: false,
  loadingReports: false,
  loadingDefaultReports: false,
  searchCriteria: {
    dateTimeFrom: dayjs().startOf("year").format("YYYY-MM-DD HH:mm"),
    dateTimeTo: dayjs().endOf("day").format("YYYY-MM-DD HH:mm"),
  },
};

export const reportingReducer = (state = reportingInitialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.LIST_CORZAP_REPORTS:
      const corzapItems = payload.returnObject?.userReports || [];
      return {
        ...state,
        corzapReports: corzapItems,
        searchCriteria: { ...getInitialFilters() },
      };
    case actionTypes.LIST_CORZAP_REPORTS_ERROR:
      return { ...state, corzapReports: [] };
    case actionTypes.LIST_CUSTOM_REPORTS:
      const customItems = payload.returnObject?.userReports || [];
      return { ...state, customReports: customItems };
    case actionTypes.LIST_CUSTOM_REPORTS_ERROR:
      return { ...state, customReports: [] };
    case actionTypes.GET_REPORT_DATA:
      return {
        ...state,
        reportData: payload.returnObject,
      };
    case actionTypes.CHANGE_SEARCH_CRITERIA:
      return {
        ...state,
        searchCriteria: { ...state.searchCriteria, ...payload },
      };
    case actionTypes.RESET_SEARCH_CRITERIA:
      return {
        ...state,
        searchCriteria: { ...getInitialFilters() },
      };
    case actionTypes.CLEAR_REPORT_DATA:
      return {
        ...state,
        reportData: {},
      };
    case actionTypes.GET_REPORT_DATA_ERROR:
      return {
        ...state,
        reportData: {},
      };
    case actionTypes.SET_LOADING_REPORT_DATA:
      return {
        ...state,
        loadingReportData: payload,
      };
    case actionTypes.SET_LOADING_REPORTS:
      return {
        ...state,
        loadingReports: payload,
      };
    case actionTypes.SET_LOADING_DEFAULT_REPORTS:
      return {
        ...state,
        loadingDefaultReports: payload,
      };
    default:
      return state;
  }
};
